import { Ref } from 'vue';
import {
  ErrorTagUtil,
  HekateDisplayForm,
  TranslationLanguage,
} from 'www-shared';
import ExternalUtil from '../ExternalUtil';
import RichMap from './RichMap';
import ErrorUtil from './ErrorUtil';

type DriftPlaybookName = 'ContactSales' | 'FreePlanPro' | 'DiscoFastlane';
export default class DriftBotUtil {
  private static readonly contactSalesLangMap = new RichMap<TranslationLanguage, number>({
    EN: 2891891, // EN
    DE: 2914498,
    FR: 2914494,
    IT: 2891891, // EN
    JA: 2891891, // EN
    ES: 2891891, // EN
    NL: 2891891, // EN
  })

  private static readonly freePlanProsLangMap = new RichMap<TranslationLanguage, number>({
    EN: 2771613, // EN
    DE: 2914501,
    FR: 2914500,
    IT: 2771613, // EN
    JA: 2771613, // EN
    ES: 2771613, // EN
    NL: 2771613, // EN
  })

  private static readonly discoFastlaneLangMap = new RichMap<TranslationLanguage, number>({
    DE: 2848258, // EN
    IT: 2848258, // EN
    FR: 2848258, // EN
    EN: 2848258, // EN
    JA: 2848258, // EN
    ES: 2848258, // EN
    NL: 2848258, // EN
  })

  /** Map a formId to a lang map of playbook IDs */
  private static readonly playbookToLangMap = new RichMap<DriftPlaybookName, RichMap<TranslationLanguage, number>>({
    ContactSales: this.contactSalesLangMap,
    FreePlanPro: this.freePlanProsLangMap,
    DiscoFastlane: this.discoFastlaneLangMap,
  })

  public static getPlaybookIdByLang(
    playbook: DriftPlaybookName,
  ):number {
    const lang = ExternalUtil.getSiteLang();

    const langMap = this.playbookToLangMap.getOrNull(playbook);
    const playbookId = (langMap) ? langMap.getOrDefaultKey(lang, 'EN') : 0;

    return playbookId;
  }

  public static showDriftBotOrThrow({
    playbook,
    formDefinition,
    redirectUrl,
  }: {
    playbook: DriftPlaybookName,
    formDefinition: Ref<HekateDisplayForm>,
    redirectUrl?: string,
  }): void {
    // get the submit data.
    const submitData = formDefinition.value.displayFields
      .map((item) => ({ name: item.htmlName, val: item.val }))
      .reduce((data: {[key:string]: string | number | boolean}, item) => {
        data[item.name] = item.val;
        return data;
      }, {});

    if (!window.drift || !window.drift.api) {
      ErrorUtil.safePostMessageToSentry({
        tag: ErrorTagUtil.hekateWarning,
        msg: `no Driftbot present form submission to form ID ${formDefinition.value.id}`,
      });

      throw new Error('no driftbot present');
    }

    const opts: { campaignId: number, followupUrl?: string } = {
      campaignId: this.getPlaybookIdByLang(playbook),
    };

    if (redirectUrl) {
      opts.followupUrl = redirectUrl;
    }

    window.drift.api.collectFormData(submitData, opts);
  }
}
